import loadable from '@loadable/component';

export const SearchLandingPageLoadable = loadable(
  () => import('./SearchLandingPage'),
  {
    resolveComponent: (module) => module.SearchLandingPage,
  },
);
